export default function getFontLocals(localAlias) {
  if (typeof localAlias === 'string') {
    return [localAlias];
  }

  if (Array.isArray(localAlias)) {
    return localAlias.slice();
  }

  return [];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela/es/getFontLocals.js
// module id = 84
// module chunks = 0